var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('p',[_c('MarkTag',{attrs:{"text":_vm.printContent,"match":_vm.getQuery}})],1),(_vm.hasAttachments)?_c('ClientFiler',{attrs:{"items":_vm.getAttachments,"showOnlyItems":true,"selectable":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }